'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagAwAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-6.10352e-05 0C9.33329 0 18.6666 -8.36893e-05 28 8.88109e-06V20C18.6667 20 9.33333 20 -3.57628e-06 20C-3.57628e-06 13.3333 0.000366758 6.66667 -6.10352e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-6.10352e-05 0L28 8.88109e-06V20H-3.57628e-06L-6.10352e-05 0Z",
          fill: "#4189DD"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.64932 3.9809L5.33509 2.66667L6.02086 3.9809L7.33509 4.66667L6.02086 5.35243L5.33509 6.66667L4.64932 5.35243L3.33509 4.66667L4.64932 3.9809Z",
          fill: "#D21034"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.64932 3.9809L5.33509 2.66667L6.02086 3.9809L7.33509 4.66667L6.02086 5.35243L5.33509 6.66667L4.64932 5.35243L3.33509 4.66667L4.64932 3.9809ZM4.15519 5.84656L5.33509 8.10777L6.51499 5.84656L8.7762 4.66667L6.51499 3.48677L5.33509 1.22556L4.15519 3.48677L1.89399 4.66667L4.15519 5.84656Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-3.57628e-06 14.6667H28V16H-3.57628e-06V14.6667Z",
          fill: "#F9D616"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M-3.57628e-06 12H28V13.3333H-3.57628e-06V12Z", fill: "#F9D616" })
    ]
  }
);
const VpFlagAwAsset = forwardRef(FlagAwAsset);

export { VpFlagAwAsset as default };
